module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-11-c30c63e73240262aa6981fdf285894f7.jpg";